import { ReceiptState, ReceiptActionTypes, ReceiptActions } from '../../types/receipt.store.type';

const initialState: ReceiptState = { isLoading: false, error: null };

export function receiptReducer(state = initialState, action: ReceiptActionTypes): ReceiptState {
    switch (action.type) {
        case ReceiptActions.RECEIPT_FETCH_BEGIN: {
            return { isLoading: true, error: null };
        }
        case ReceiptActions.RECEIPT_FETCH_SUCCESS: {
            return { isLoading: false, error: null, receipt: action.payload };
        }

        case ReceiptActions.RECEIPT_FETCH_ERROR: {
            return { isLoading: false, error: action.payload };
        }
        default:
            return state;
    }
}
